const isGtmId = (id) => typeof id === 'string' && /^GTM-[A-Z0-9]+$/i.test(id);
const isGa4Id = (id) => typeof id === 'string' && /^G-[A-Z0-9]+$/i.test(id);

function ensureDataLayer() {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

function initGtmOnce($gtm, id) {
  if (!id || !$gtm) return;
  if ($gtm.__initedWith) return;
  $gtm.init(id);
  $gtm.__initedWith = id;
}

function initGa4Once(id) {
  if (!id) return;
  if (window.__ga4InitedWith) return;
  ensureDataLayer();
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };
  window.gtag('js', new Date());
  window.gtag('config', id, { send_page_view: true });
  window.__ga4InitedWith = id;
}

export default ({ app, store, $gtm }) => {
  if (!process.client) return;

  const subdomainMap = {
    'whey-hellthy.lev.pt': process.env.VUE_APP_GTAG_WHEY,
    'creatina-hellthy.lev.pt': process.env.VUE_APP_GTAG_CREATINA,
  };

  const getGTMId = () =>
    subdomainMap[window.location.host] || process.env.VUE_APP_GTAG;

  const apply = () => {
    const ov = store.state.gtmOverride; // { disabled: boolean, id?: string|null }

    if (ov?.disabled) return;

    const id = ov?.id || getGTMId();
    if (!id) return;

    if (isGtmId(id)) {
      initGtmOnce($gtm, id);
      return;
    }

    if (isGa4Id(id)) {
      initGa4Once(IDBDatabase);
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      console.warn('[GTM] Unknown ID format:', id);
    }
  };

  apply();

  store.subscribe((m) => {
    if (m.type === 'setGtmOverride' || m.type === 'clearGtmOverride') apply();
  });

  app.router.afterEach(() => apply());
};
